import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./MaterialIntakeFile.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import Asterisks from "../../../custom/components/Asterisks/Asterisks.js";
import { validate } from "../../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import { loaderOverlay } from "../../../Style/loaderOverly.js";
import DatePicker from "../../../custom/components/Date-Picker/DatePicker.js";

const MaterialIntakeCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const schema = localStorage.getItem('schema')
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  // role
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [materialSelectOptions, setMaterialSelectOptions] = useState([])

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSelectOptions, setCustomerSelectOptions] = useState([])

  //Status 'Pending', 'Inspected', 'Assigned to technician', 'Repaired', 'Scrapped', 'Dispatched'
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusSelectOptions, setStatusSelectOptions] = useState([
    { value: 1, label: "Pending" },
    { value: 2, label: "Inspected" },
    { value: 3, label: "Assigned to technician" },
    { value: 4, label: "Repaired" },
    { value: 5, label: "Scrapped" },
    { value: 6, label: "Dispatched" },
  ])

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);




  useEffect(() => {
    getMaterialData()
    getCustomerData()
  }, [])


  const getEditData = async (id) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      }

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        let data = responseData.data[0];
        const receivedDate = new Date(data.received_date).toLocaleDateString()
        const [day, month, year] = receivedDate?.split("/");
        const formatted = `${year}-${month}-${day}`;
        data = { ...data, received_date: formatted }
        setFormData({ inputData: data })
        setSelectedMaterial({ value: data?.material_id, label: data?.material?.name })
        setSelectedCustomer({ value: data?.customer_id, label: data?.customer?.client_name })
        statusSelectOptions.map((sts) => {
          if (data.status === sts.label) {
            setSelectedStatus({ value: sts.value, label: sts.label })
          }
        })
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getMaterialData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "material_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.name
      }));
      setMaterialSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };

  const getCustomerData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "client_masters",
        whereCondition: {
          is_active: true
        },
        schema: schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.client_name
      }));
      setCustomerSelectOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };




  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {

      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleMaterialSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      material_id: selectedValue,
    });

    setSelectedMaterial(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      material_id: fieldError?.material_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        material_id: selectedValue,
      },
    }));
  };

  const handleCustomerSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      customer_id: selectedValue,
    });

    setSelectedCustomer(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      customer_id: fieldError?.customer_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        customer_id: selectedValue,
      },
    }));
  };

  const handleStatusSelect = (options) => {
    const selectedValue = options ? options.label : "";
    const fieldError = validate(validationType, {
      status: selectedValue,
    });

    setSelectedStatus(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      status: fieldError?.status || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        status: selectedValue,
      },
    }));
  };



  // Submit

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)
      if (JSON.stringify(validationErrors) !== "{}") return
      // Additional validation for `user_documents`



      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData }

      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData }
      }
      payload.inputData = { ...payload.inputData, received_by: userDetails?.id }

      // console.log(payload)
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {

        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };



  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <TextInput
            label="Intake Number"
            name="intake_no"
            disabled={true}
            value={formData?.inputData?.intake_no}
            onChange={onInputChange}
            placeholder="Intake Number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.intake_no}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="material"
            options={materialSelectOptions}
            value={selectedMaterial}
            onSelect={handleMaterialSelect}
            placeholder="Select Material"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.material_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="customer"
            options={customerSelectOptions}
            value={selectedCustomer}
            onSelect={handleCustomerSelect}
            placeholder="Select Customer"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.customer_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <DatePicker
            label="Received Date"
            name="received_date"
            value={formData?.inputData?.received_date}
            onChange={onInputChange}
            placeholder="Received Date"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.received_date}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="status"
            options={statusSelectOptions}
            value={selectedStatus}
            onSelect={handleStatusSelect}
            placeholder="Select Status"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.status}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Issue Description"
            name="issue_descriptions"
            value={formData?.inputData?.issue_descriptions}
            onChange={onInputChange}
            placeholder="Issue Description"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.issue_descriptions}
          />
        </Col>

      </Row>

      <Row className="mt-4">

        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default MaterialIntakeCreate;
